import { useFeatureIsOn } from "@growthbook/growthbook-react";

export const NEW_REQUEST_ACCESS_FEATURE_FLAG = "new-request-access";

export function useNewRequestAccessFeatureFlagOn(): boolean {
	return useFeatureIsOn(NEW_REQUEST_ACCESS_FEATURE_FLAG);
}
